import { Tool } from 'src/app/models/tool.model';
import { SubTipoFerramenta } from 'src/app/models/subtipoferramenta.model';
import { TipoFerramenta } from './../../models/tipoferramenta.model';
import { teams } from './../../resources/teams';
import { Employee } from './../../models/employee.model';
import { AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';

import { countries } from 'src/app/resources/countries';
import { FormModel } from 'src/app/models/form.model';

import { SelectEvent, FileRestrictions } from '@progress/kendo-angular-upload';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { NotificationService } from '@progress/kendo-angular-notification';
import { Team } from 'src/app/models/team.model';
import { Enum } from 'src/app/models/enum.model';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { Site } from 'src/app/models/site.model';
import { ApiService } from 'src/app/services/http/api.service';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { IntlService } from '@progress/kendo-angular-intl';


@Component({
    selector: 'app-tools-form-component',
    templateUrl: './tools-form.component.html'
})
export class ToolsFormComponent  extends DialogContentBase  implements OnInit {
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;

    public formGroup: FormGroup = new FormGroup({});
    public countries = countries;
    public phoneNumberMask = '(+9) 0000-000-00-00';
    public fileRestrictions: FileRestrictions = {
        allowedExtensions: ['.png', '.jpeg', '.jpg']
    };
    public avatars?: NodeList;
    public listItemsTipos: Array<TipoFerramenta> =[];
    public listItemsSubTipos: Array<SubTipoFerramenta> = [];
    public listItemsSubTiposFiltrados: Array<SubTipoFerramenta> = [];
 

   

  
     public selectedTeams: any[] = [];

    public formValue: Tool  = {
        id: 0,
        marca: '',
        modelo: '',
        refTipoFerramenta: 0,
        refSubTipoFerramenta: 0,
        nomeTipoFerramenta: '',
        nomeSubTipoFerramenta: '',
        descricao: '',
        identificacao: '',
        numeroDeSerie: '',
        estado: 0,
        abatida: false,
        bloqueada: false,
        levantada: false,
        estadoDescricao: '',
        condicaoDescricao: '',
        avariaDescricao: '',
        nomeUtilizadorNaPosse: '',
        cartaoUtilizadorNaPosse: '',
        avariada: false
    };

    public customMsgService: CustomMessagesService;

    constructor(public msgService: MessageService, private notificationService: NotificationService,private api: ApiService,public override dialog: DialogRef,private intl: IntlService) {
       super(dialog);
      
        this.customMsgService = this.msgService as CustomMessagesService;
        this.placeHolderTipoFerramenta.nome = this.customMsgService.translate('selecionartag');
        this.placeHolderSubtipoFerramenta.descricao = this.customMsgService.translate('naoAtribuidoTag');


        this.api
        .getRequest<BaseHttpResponse<TipoFerramenta[]>>("TipoFerramentas/GetTiposDeFerramentas")
        .then((data) => {
            this.listItemsTipos = data.value;
          
        })
        .catch((err) => {});

       

        this.api
        .getRequest<BaseHttpResponse<SubTipoFerramenta[]>>("SubTipoFerramenta/GetSubTiposFerramentas")
        .then((data) => {
            this.listItemsSubTipos = data.value;
           // this.listItemsSubTiposFiltrados =data.value;
           this.filterSubTipos(this.formValue?.refTipoFerramenta);
           this.setFormValues();
          
        })
        .catch((err) => {});

        
     
        var objs = undefined ;
    
   
        if(this.formValue?.refTipoFerramenta!=0) 
            objs =  { id:this.formValue?.refTipoFerramenta};


       
        this.formGroup = new FormGroup({
           
           
          
            refTipoFerramenta: new FormControl(objs, [Validators.required]),
            refSubTipoFerramenta: new FormControl({ id:this.formValue?.refSubTipoFerramenta}),
            bloqueada: new FormControl(this.formValue?.bloqueada),
            abatida: new FormControl(this.formValue?.abatida),
            descricao: new FormControl(this.formValue?.descricao),
            identificacao: new FormControl(this.formValue?.identificacao, [Validators.required]),
            avariada: new FormControl(this.formValue?.numeroDeSerie),
          
            numeroDeSerie: new FormControl(this.formValue?.avariada,[Validators.required]),
        });
    }
 public placeHolderTipoFerramenta: any = {
            nome: "",
            id: undefined,
          };

          public placeHolderSubtipoFerramenta: any = {
            descricao: "",
            id: undefined,
          };
       
  
 ngOnInit() {
    // this.api
    //     .getRequest<BaseHttpResponse<TipoFerramenta[]>>("Tipos/GetTiposDeFerramentas")
    //     .then((data) => {
    //         this.listItemsEquipas = data.value;

    //         var ids = this.formValue.iDsEquipas.map(a => a);
    //         var lll = this.listItemsEquipas.filter(x=>  ids.find(f=> f===x.id));
    //         this.formGroup.controls['iDsEquipas'].setValue( lll);

    //     })
    //     .catch((err) => {});

    //     this.api
    //     .getRequest<BaseHttpResponse<SubTipoFerramenta[]>>("Utilizador/GetSubTiposDeFerramentas")
    //     .then((data) => {
    //         this.listItemsPerfil = data.value;
          
    //     })
    //     .catch((err) => {});

    //     this.api
    //     .getRequest<BaseHttpResponse<Enum[]>>("Utilizador/GetLinguas")
    //     .then((data) => {
    //         this.listItemsLinguas = data.value;
          
    //     })
    //     .catch((err) => {});
  }
    public setFormValues() {
        // const form = localStorage.getItem('form');
        // if (form) {
        //     this.formValue = JSON.parse(form);
        // }


    //     id: number;
    //     marca: string;
    //      modelo: string;
    //     refTipoFerramenta: number;
    //     refSubTipoFerramenta: number;
    //    nomeTipoFerramenta: string;
    //      nomeSubTipoFerramenta: string;
    //      descricao: string;
    //      identificacao: string;
    //      numeroDeSerie: string;
    //     estado: number;

     // var arr =this.listItemsEquipas this.formValue.iDsEquipas.map(a => { return { id:a }; } );

    var objs = undefined ;
    
   
    if(this.formValue?.refTipoFerramenta!=0) 
        objs =  { id:this.formValue?.refTipoFerramenta};

        this.formGroup = new FormGroup({
           
          
            refTipoFerramenta: new FormControl(objs, [Validators.required]),
            refSubTipoFerramenta: new FormControl({ id:this.formValue?.refSubTipoFerramenta}),
            descricao: new FormControl(this.formValue?.descricao),
            identificacao: new FormControl(this.formValue?.identificacao, [Validators.required]),
            abatida: new FormControl(this.formValue?.abatida),
            bloqueada: new FormControl(this.formValue?.bloqueada),
            numeroDeSerie: new FormControl(this.formValue?.numeroDeSerie, [Validators.required]),
            avariada: new FormControl(this.formValue?.avariada),
           
        });

        //this.filterSubTipos(this.formValue?.refTipoFerramenta);
 
    }


    public selectionChange(value: any): void {
     
        this.filterSubTipos(value.id);
    


    }
   

    public saveChanges(): void {
        this.formGroup.markAllAsTouched();


     


this.formValue.refTipoFerramenta =this.formGroup.controls['refTipoFerramenta'].value.id;
this.formValue.refSubTipoFerramenta=this.formGroup.controls['refSubTipoFerramenta'].value.id;
this.formValue.descricao= this.formGroup.controls['descricao'].value;
this.formValue.identificacao=this.formGroup.controls['identificacao'].value;

this.formValue.numeroDeSerie =this.formGroup.controls['numeroDeSerie'].value;

this.formValue.bloqueada=this.formGroup.controls['bloqueada'].value;
this.formValue.abatida=this.formGroup.controls['abatida'].value;
this.formValue.avariada=this.formGroup.controls['avariada'].value;

       
        this.api.save<BaseHttpResult>('Ferramentas/Save',this.formValue).then(res => {
            if (res.ok) {
                this.formGroup.markAsPristine();
                this.dialog.close();
                
                this.notificationService.show({
                content:this.customMsgService.translate('registoGravadoComSucesso') ,
                animation: { type: 'slide', duration: 500 },
                position: { horizontal: 'center', vertical: 'bottom' },
                type: { style: 'success', icon: true },
                hideAfter: 2000
                 });
            } else {
                this.notificationService.show({
                    appendTo: this.container,
                    content:res.message ,
                    animation: { type: 'slide', duration: 500 },
                    position: { horizontal: 'center', vertical: 'top' },
                    type: { style: 'error', icon: true },
                    hideAfter: 4000
            
                });
            //   const sb = this.snackBar.open(res.message, "Fechar", {
            //     verticalPosition: "top",
            //     panelClass: ["red-snackbar"], this.customMsgService.translate('selecionartag') 
            //   });
            }
          });

       
    }

    public cancelChanges(): void {
        this.setFormValues();
    }

  
public filterSubTipos(idTipo:number)
{
 
    if(idTipo==0)
    this.listItemsSubTiposFiltrados=  this.listItemsSubTipos;
    else
    this.listItemsSubTiposFiltrados=  this.listItemsSubTipos.filter(_s=> _s.refTipoFerramenta === idTipo) ;

}
   

    
}
